<template>
  <div class="container-fluid">
    <table class="table" v-if="!showLoader" style="table-layout:fixed;">
            <thead style="position: sticky;">
                <tr>
                  <th class="text-center" style="width:3%">
                    <input v-model="selectAllDsp" type="checkbox" @click="toggleSelectAllHandler" />
                  </th>
                  <th style = "width:14%">Advertiser</th>
                  <th style = "width:28%">Order</th>
                  <th style = "width:8%">Type</th>
                  <th style = "width:12%">Brand</th>
                  <th style = "width:12%">Category</th>
                  <th style = "width:10%">Sub-Category</th>
                  <th style = "width:10%">Style</th>
                  <th style = "width:10%">Tactic 1</th>
                  <th style = "width:10%">Tactic 2</th>
                  <th style = "width:10%">GL</th>
                  <th style = "width:8%">Start Date</th>
                  <th style = "width:8%">End Date</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in dspRows" :key="item.id + '_' + item.title + '_' + index" :class="index%2==0?'even':''">
                    <td class="text-center">
                      <input
                        type="checkbox"
                        :id="item.order_id"
                        :value="item.order_id"
                        v-model="item.checked"
                        @change="selected(item)"
                      />
                    </td>
                    <td>
                      {{ item.advertiser_name }}
                    </td>
                    <td>
                      <a class="grid-item ico-add-new" href="javascript:void(0)" @click="navigateToAddToDspCampaign(item)"> {{ item.name }} </a> <br/>
                      Order ID {{ item.order_id }}
                    </td>
                    <td >DSP</td>
                    <td >{{ item.brand }}</td>
                    <td >{{ item.product_category }}</td>
                    <td >{{ item.subcategory}}</td>
                    <td >{{ item.style }}</td>
                    <td >{{ item.tactic_1 }}</td>
                    <td >{{ item.tactic_2 }}</td>
                    <td >{{ item.gl }}</td>
                    <td >{{ item.start_date }}</td>
                    <td >{{ item.end_date }}</td>
                    <td>
                        <div class="row-add-edit" id = "DSP-list-drop-down">
                            <a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown" ></a>
                            <div class="dropdown-menu remove-style" aria-labelledby="dropdownMenuButton" style="" id = "dsp-list-data">
                                <a class="grid-item ico-delete" href="javascript:void(0)" @click="navigateToAddToDspCampaign(item)">Delete Tag</a>
                                <a class="grid-item ico-edit" href="javascript:void(0)" @click="navigateToAddToDspCampaign(item)">Add Tag</a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>

        </table>
        <!-- style="margin-left: 20%; margin-right: 20%; text-align: center; margin-top: 10%; font-weight: bold; font-size: large;" -->
        <!-- <div v-if="!showDspRows && !showLoader" style="margin-left: 20%; margin-right: 20%; text-align: center; margin-top: 10%; font-weight: bold; font-size: large;">
          Select an advertiser to view order data.
        </div> -->
</div>
</template>

<script>
import NoDataAvailable from "@/components/NoDataAvailable.vue";

export default {
    components: {
      NoDataAvailable
    },
    data() {
      return {
        totalNoOfPages:1,
        selectAllDsp: false,
      }
    },
    methods: {
      navigateToAddToDspCampaign(item) {
				this.$store.commit('updateDspAdvertiser', item)
        this.$router.push('dspAdvertiser/' + item.order_id);
      },
      selected(item){
        if (item.checked){
          this.bulkDspIds.push(item.order_id)
        } else {
          this.selectAllDsp = false
          this.bulkDspIds = this.bulkDspIds.filter(id => id !== item.order_id)
        }
      },
      toggleSelectAllHandler(){
        if (this.selectAllDsp) {
          this.dspRows = this.dspRows.map(row => ({...row, checked: false}))
        } else {
          this.dspRows = this.dspRows.map(row => ({...row, checked: true}))
        }

        this.bulkDspIds = this.dspRows.filter(row => row.checked === true).map(selectedRow => selectedRow.order_id)
      }
    },
    computed: {
      bulkDspIds: {
        set(val) {
          this.$store.state.selectedBulkDsp = val
        },
        get() {
          return this.$store.state.selectedBulkDsp
        }
      },
      dspRows: {
        set(val) {
          this.$store.state.dspTagList = val;
        },
        get() {
          return this.$store.state.dspTagList;
        },
      },
      showDspRows: {
        set(val) {
          this.$store.state.showDspRows = val;
        },
        get() {
          return this.$store.state.showDspRows;
        },
      },
      showLoader: {
        get() {
          return this.$store.getters["getShowLoader"];
        },
      },

    },
}
</script>
<style>
.advertiser_id_col {
  font-size: small;
  font-weight: bold;
  font-style: italic;
}
.order_id_col {
  font-size: small;
  font-weight: bold;
  font-style: italic;
}
.dsp_row_count {
  float: right;
  padding: 15px;
}

</style>

<style lang="scss">

    .table thead {
      background-color: white;
      top: 0;
      z-index: 1;
    }
    .table thead th {
      background-color: white;
      border: 0px !important;
      color: #333333;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 900;
      letter-spacing: -0.07px;
      line-height: 19px;
    }
    .table tbody td {
      border: 0px !important;
      color: #333333;
      font-family: Roboto;
      font-size: 16px;
      letter-spacing: -0.07px;
      line-height: 23px;
      word-wrap: break-word;
    }
    .table tbody tr.even {
      background-color: #fafafa;
    }
    .table tbody tr:hover {
      background-color: white;
    }
    .table tbody tr.even:hover {
      background-color: #fafafa;
    }
    .table tbody td{
      vertical-align: top !important;
      .row-add-edit{
        padding-top:3px;
        max-width:10px;
        .item-add-edit{
          display: block !important;
          opacity: 0.5 ;
        }
        .item-add-edit:hover{
          opacity: 1 !important;
        }
      }
      .label-info{
        background-color: #5bc0de;
      }
      .label {
        display: inline;
        padding: 0.2em 0.6em 0.3em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 0.25em;
      }
    }
    .bulk_action {
      height: 43px;
      width: 146px;
      border-radius: 21.5px;
      background-color: #ffbf3f;
    }

</style>


<style lang="scss">
.hightlight {
    background-color: #3da3a7 !important;
    color: #fff;
}
.link { cursor: pointer; }

</style>
